import { Component, inject, TemplateRef } from '@angular/core';
import { ToasterService } from '../../services/toaster/toaster.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-toaster',
  imports: [NgbToastModule,CommonModule ],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss'
})
export class ToasterComponent {
  public toastService = inject(ToasterService);
  isTemplate(toast: any): boolean {
    return toast.textOrTpl instanceof TemplateRef;
  }

  // showSuccess() {
  //   this.toastService.show('This is a success message!', { classname: 'bg-success text-light', delay: 5000 });
  // }

  // showError() {
  //   this.toastService.show('Something went wrong!', { classname: 'bg-danger text-light', delay: 5000 });
  // }

  // showInfo() {
  //   this.toastService.show('This is an info message.', { classname: 'bg-info text-light', delay: 5000 });
  // }

  // showWarning() {
  //   this.toastService.show('This is a warning message.', { classname: 'bg-warning text-dark', delay: 5000 });
  // }
}
